export default __webpack_public_path__ + "static/media/home.ead8d37b.svg";